/* eslint-disable */
import ctype from 'component-type';

const expected = `object`;

/**
 * Check whether or not a given `item` is a Object
 * @param {any} item The `item` to check
 * @returns {boolean} Wheter or not the `item` is a indeed an Object
 */
const isObject = (item) => ctype(item) === expected;

export default isObject;
